import { render, staticRenderFns } from "./BusinessTipReport.vue?vue&type=template&id=a7054fbc"
import script from "./BusinessTipReport.vue?vue&type=script&lang=js"
export * from "./BusinessTipReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports